var map = {
	"./all.svg": 565,
	"./bug.svg": 8939,
	"./dark.svg": 3893,
	"./dragon.svg": 1275,
	"./electric.svg": 3247,
	"./fairy.svg": 522,
	"./fight.svg": 370,
	"./fighting.svg": 9382,
	"./fire.svg": 5251,
	"./flying.svg": 8212,
	"./ghost.svg": 5664,
	"./grass.svg": 5025,
	"./ground.svg": 6430,
	"./ice.svg": 9254,
	"./normal.svg": 6762,
	"./poison.svg": 9105,
	"./psychic.svg": 1632,
	"./rock.svg": 333,
	"./steel.svg": 309,
	"./water.svg": 5060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4989;